import { addLocaleData } from 'react-intl';
import es from 'react-intl/locale-data/es';

import { setTranslations as setNavTranslations } from '@99designs/globalnav/locale-data';
import navEs from '@99designs/globalnav/locale-data/es';

setNavTranslations(navEs);
addLocaleData(es);



// WEBPACK FOOTER //
// ./src/web/js/locale-data/es.js